export default __webpack_public_path__ + "static/media/seth.f3beacaf.png";